import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { PublishDialog } from 'modules/engagement_surveys/components/SurveyResourceHeader/PublishDialog'

type Data = {
  surveyId: string
}

export const PublishSurveyActivity: ActivityComponent<Data> = ({ surveyId }) => {
  const { open, closeActivity } = useActivity()

  if (!open) return null

  return <PublishDialog surveyId={Number(surveyId)} onClose={closeActivity} />
}
